<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';

export default {
  components: {
    PageHeader,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      channelName: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    channelName: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const parallelConversationChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.channelName,
            channel: {
              type: 'parallel_conversation',
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: parallelConversationChannel.id,
          },
        });
      } catch (error) {
        // The user gets a generic alert on purpose — the API error carries no copy
        // worth surfacing here — but the original reason still has to reach the
        // console, otherwise a failed inbox creation is undebuggable in production.
        // eslint-disable-next-line no-console
        console.error('[ParallelConversation] channel creation failed', error);
        useAlert(
          this.$t('INBOX_MGMT.ADD.PARALLEL_CONVERSATION_CHANNEL.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div
    class="border border-slate-25 dark:border-slate-800/60 bg-white dark:bg-slate-900 h-full p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] flex-shrink-0 flex-grow-0"
  >
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.PARALLEL_CONVERSATION_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.PARALLEL_CONVERSATION_CHANNEL.DESC')"
    />
    <form class="flex flex-wrap mx-0" @submit.prevent="createChannel()">
      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: v$.channelName.$error }">
          {{
            $t('INBOX_MGMT.ADD.PARALLEL_CONVERSATION_CHANNEL.CHANNEL_NAME.LABEL')
          }}
          <input
            v-model.trim="channelName"
            type="text"
            :placeholder="
              $t(
                'INBOX_MGMT.ADD.PARALLEL_CONVERSATION_CHANNEL.CHANNEL_NAME.PLACEHOLDER'
              )
            "
            @blur="v$.channelName.$touch"
          />
          <span v-if="v$.channelName.$error" class="message">{{
            $t('INBOX_MGMT.ADD.PARALLEL_CONVERSATION_CHANNEL.CHANNEL_NAME.ERROR')
          }}</span>
        </label>
      </div>

      <div class="w-full">
        <woot-submit-button
          :loading="uiFlags.isCreating"
          :button-text="
            $t('INBOX_MGMT.ADD.PARALLEL_CONVERSATION_CHANNEL.SUBMIT_BUTTON')
          "
        />
      </div>
    </form>
  </div>
</template>
